<div class="selected-addr-comp mb-3" style="padding: 0 20px;" *ngIf="isCreateOredit">
    <div class="selected-add-edit row">
        <div class="col-md-12 mb-3" *ngIf="showAddressType">
            <label class="label mt-2 mb-2">{{l("AddressType")}}</label>
            <div class="w-50 d-inline-block ml-2 ">
                <p-dropdown [(ngModel)]="addType" id="AddCountry" [options]="AddressTypesList" name="Addresstype"
                    styleClass="form-control aria-select  " [placeholder]="'PleaseSelect' | localize"
                    (onChange)="selectAddressType()">
                </p-dropdown>
            </div>


        </div>
        <div class="col-md-12 mb-3">
            <label class="label mt-2 mb-2 mr-4">{{l("Address")}}</label>
            <textarea class="form-control   d-inline-block ml-md-4 textAr" style="min-height: 80px;"
                readonly>{{selectedAddress?.addressLine1 ? selectedAddress?.addressLine1+' ,' : ''}}{{selectedAddress?.addressLine2 ? selectedAddress?.addressLine2+' ,' : ''}}{{ selectedAddress?.city ? selectedAddress?.city+' ,' : ''}}{{selectedAddress?.state ? selectedAddress?.state+' ,' : ''}}{{ selectedAddress?.countryName ? selectedAddress?.countryName : selectedAddress?.countryCode ? selectedAddress?.countryCode  +' ,' : ''}}{{selectedAddress?.postalCode ? selectedAddress?.postalCode : ''}}</textarea>
            <div class="pull-right">
                <button *ngIf="canChange" class="savebtn text-center btn float-right mt-2" (click)="showAddressList()">
                    {{l("Change")}}
                    <i class="fas fa-edit ml-1 mr-1"></i>
                </button>
            </div>

        </div>

    </div>
</div>
<div class="selected-addr-comp view-mode mb-3" *ngIf="!isCreateOredit">
    <div class="selected-add-view row">
        <div class="col-md-12" *ngIf="showAddressType">
            <label class="label mt-2 mb-2">{{l("AddressType")}} :</label>
            <label class="label mt-2 mb-2 add-type ml-3" *ngIf="selectedAddressDetails"></label>
            <label class="label mt-2 mb-2 selected-add ml-4" *ngIf="!selectedAddressDetails">-</label>
        </div>
        <div class="col-md-12">
            <label class="label mt-2 mb-2 mr-4" style="margin-left: 10px;">{{l("Address")}} :</label>
            <label class="label mt-2 mb-2 selected-add ml-4" *ngIf="selectedAddressDetails">
                {{selectedAddressDetails?.addressLine1+' ,'}}{{selectedAddressDetails?.addressLine2+'
                ,'}}{{selectedAddressDetails?.city+' ,'}}{{selectedAddressDetails?.state+'
                ,'}}{{selectedAddressDetails?.countryName ? selectedAddressDetails?.countryName :
                selectedAddressDetails?.countryCode+' ,'}}{{selectedAddressDetails?.postalCode}}
            </label>
            <label class="label mt-2 mb-2 selected-add ml-4" *ngIf="!selectedAddressDetails">-</label>
        </div>

    </div>

</div>
<div class="address-wrapper p-2 view-mode" *ngIf="showAddList">
    <div class="address-form">
        <div class="adrress-title">
            <h3>{{l("SelectAddresses")}}</h3>
            <p class="mb-0">{{l("PleaseSelectFromTheSavedAddressesBelow")}}</p>
        </div>
        <hr>
        <div class="filter-add-comp col-12 mb-1 d-flex">
            <div class="w-100">
                <input class="filter-adress-list form-control w-100" placeholder="Lookin in addresses .." #filterVal
                    (keyup)="filterAddressList(filterVal.value)" type="text" />
                <i class="fa fa-search search-input-icon" aria-hidden="true"></i>
            </div>
            <div class="d-flex justify-content-end" *ngIf="showAddBtn && showEditDelBtn && fromSalesRep">
                <button class="ml-2 add-new-add-btn" (click)="openAddAddressForm()">
                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>{{l("AddANewAddress")}}
                </button>
            </div>
        </div>
        <ul class="address-warper-cont">
            <li *ngFor="let address of savedAddressesList" class="address-warper mt-3 mb-3 pt-1 pb-1">
                <div class="d-flex align-items-center">
                    <input *ngIf="selectedAddress" class="form-control" type="radio"
                        (change)="selectAddress(address.id)" [checked]="address.id==selectedAddress.id"
                        name="selectedAdd" [id]="address.id" />
                    <input *ngIf="!selectedAddress" class="form-control" type="radio"
                        (change)="selectAddress(address.id)" name="selectedAdd" [id]="address.id" />
                    <label> {{ address?.addressLine1 ? address?.addressLine1+' ,' : ''}}{{ address?.addressLine2 ?
                        address?.addressLine2+' ,' : ''}}{{address?.city ? address?.city+' ,' : ''}}{{ address?.state ?
                        address?.state+' ,' : ''}}{{ address?.countryName ? address?.countryName +',' :
                        address?.countryCode ? address?.countryCode +' ,' : ''}}{{address?.postalCode ?
                        address?.postalCode : ''}}</label>
                </div>
                <div class="p mt-2 d-flex" *ngIf="showAddBtn && showEditDelBtn && fromSalesRep">
                    <button (click)="editAddress(address.id)" class="acBtn">
                        <img class="mx-1" style="height: 20px;" src="../../../../../assets/icons/edit-icon.png">




                        <p>{{l("Edit")}}</p>
                    </button>
                    <button
                        (click)="(appTransactionsForViewDto?.buyerCompanySSIN == '' || appTransactionsForViewDto?.buyerCompanySSIN == null) && ((currentTab == 4 && shipInfoIndex == 2) ||  (currentTab == 5 && billingIndexInfo == 1))  ? deleteTempAddress(address.id):  deleteAddress(address.id)"
                        class="acBtn">
                        <img class="mx-1" style="height: 20px;" src="../../../../../assets/icons/fluent_delete.png">


                        <p class="delText">{{l("Delete")}}</p>
                    </button>

                </div>
            </li>
        </ul>
        <label class="noAddressMsg" *ngIf="savedAddressesList.length==0"> No Addresses found</label>

    </div>
</div>

<div class="address-wrapper p-2 add-edit-mode" *ngIf="openAddNewAddForm">
    <div class="address-form" *ngIf="showAddBtn">
        <div class="adrress-title">
            <h3 *ngIf="!addressIdForEdit">{{l("AddNewAddressDetails")}}</h3>
            <h3 *ngIf="addressIdForEdit">{{l("EditAddress")}}</h3>
            <p class="mb-0">{{l("PleaseEnterThenewAddressInformation")}}</p>
        </div>
        <hr>
        <form class="form" #addressForm="ngForm" method="post" novalidate
            (ngSubmit)="(appTransactionsForViewDto?.buyerCompanySSIN == '' || appTransactionsForViewDto?.buyerCompanySSIN == null) && (currentTab == 4 && (shipInfoIndex == 2) ||  (currentTab == 5 && billingIndexInfo == 1)) ? savetempAddress(addressForm) :  saveAddress(addressForm)">

            <div class="row">
                <div class="col-12">
                    <label class="label mt-2 mb-2">{{l("Code")}} *</label>
                    <input type="text" placeholder="Adress Code..." class="form-control w-100" name="addressCode"
                        [(ngModel)]="addressCode" #Code="ngModel" required maxlength="6" minlength="1" />

                </div>
                <div class="col-12">
                    <label class="label mt-2 mb-2">{{l("Name")}} *</label>
                    <input type="text" placeholder="Adress Name..." class="form-control w-100" name="name"
                        [(ngModel)]="name" #Name="ngModel" required />

                </div>
                <div class="col-12">
                    <label class="label mt-2 mb-2">{{l("AddressLineOne")}} *</label>
                    <input type="text" placeholder="Adress Line 1..." class="form-control w-100" name="address1"
                        [(ngModel)]="address1" #addressOne="ngModel" required />
                </div>
                <div class="col-12">
                    <label class="label mt-2 mb-2">{{l("AddressLineTow")}}</label>
                    <input type="text" placeholder="Adress Line 2..." class="form-control w-100" name="address2"
                        [(ngModel)]="address2" #addressTwo="ngModel" />
                </div>
                <div class="col-12">
                    <label class="label mt-2 mb-2">{{l("City")}} *</label>
                    <input type="text" placeholder="City..." class="form-control w-100" name="cityAddress"
                        [(ngModel)]="city" #cityAddress="ngModel" required/>
                </div>
                <div class="col-12">
                    <label class="label mt-2 mb-2">{{l("State")}} *</label>
                    <input type="text" placeholder="State..." class="form-control w-100" name="State"
                        [(ngModel)]="state" #AddState="ngModel" required />


                </div>
                <div class="col-md-6">
                    <label class="label mt-2 mb-2">{{l("PostalCode")}} * </label>
                    <input type="text" placeholder="Postal Code 1..." class="form-control w-100" name="postalCode"
                        [(ngModel)]="postalCode" #postal_Code="ngModel" required pattern="^[a-zA-Z0-9- ]+$" maxlength="20" />
                </div>
                <div class="col-md-6" *ngIf="countries.length>0">
                    <label class="label mt-2 mb-2">{{l("Country")}} </label>
                    <p-dropdown id="AddCountry" [options]="countries" [(ngModel)]="selectedCountry"
                        name="AddressCountry" styleClass="form-control aria-select"
                        [placeholder]="'PleaseSelect' | localize">
                    </p-dropdown>

                </div>
            </div>
            <hr>
            <div class="btns mx-3 d-flex align-items-center justify-content-sm-end py-3">
                <button class="btn cancel" (click)="discardAddressForm()"
                    [disabled]="savedAddressesList.length==0">{{l("Cancel")}}</button>
                <button class="btn save" [buttonBusy]="saving" [busyText]="'emptyText'"
                    [disabled]="!addressForm.form.valid" type="submit">
                    {{l("Save")}}
                </button>
            </div>
        </form>

    </div>
</div>